import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6022ed76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resource-wrap" }

import { reactive, ref, onMounted } from 'vue';
import { cloneDeep } from 'lodash';
import ResourceSearch from './components/resourceSearch.vue';
import ResourceTable from './components/resourceTable.vue';
import { getResourceList } from '@/api/resource';
import Pagination from '@/components/bussiness/Pagination/Index.vue';
import EditResourceDrawer from './components/editResourceDrawer.vue';
import { getLoginProjects } from '@/api/myAuth';
import { getAllDataWithCursor } from '@/api/common';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const paginationObj = reactive({
  pageNum: 1,
  pageSize: 10,
  totalCount: 0
});

let formData: {
  resourceName?: string;
  projectIds?: number[];
} = {
  resourceName: ''
};

const projectList = ref<Project.ProjectItem[]>([]);

const loading = ref(true);
const tableList = ref<Resource.ResourceItem[]>([]);

// 注意： 这里由于后端方案的问题，前端实现：拉取projectid下全量数据，前端进行分页和检索
const getList = async () => {
  const query = {
    ...formData,
    page: {
      cursor: 0
    }
  };
  try {
    loading.value = true;
    const res = await getAllDataWithCursor(getResourceList, query, 'resources');
    const { code } = res || {};
    if (`${code}` === '0') {
      // 先前端匹配资源名称，不能后端匹配，否则会丢掉不符合条件的父子节点
      let flatTargetList: Resource.ResourceItem[] = [];
      const data = res.data as Resource.ListData;
      if (formData.resourceName) {
        flatTargetList = data.resources.filter(
          (item) => item.resourceName.indexOf(formData.resourceName as string) >= 0
        );
      } else {
        flatTargetList = data.resources;
      }

      const allResourceMap = new Map<number, Resource.ResourceItem>();
      data.resources.forEach((item) => {
        allResourceMap.set(item.resourceId as number, cloneDeep(item));
      });

      // 将扁平化搜索结果数据组成树形并根据顶级节点进行分页
      const { pageData, totalCount } = frontSearch(flatTargetList, allResourceMap);

      tableList.value = pageData;
      paginationObj.totalCount = totalCount;
    }
  } finally {
    loading.value = false;
  }
};

// 检索树，然后进行分页
const frontSearch = (
  flatTargetList: Resource.ResourceItem[],
  allResourceMap: Map<number, Resource.ResourceItem>
) => {
  // valid比起target多了一些祖先节点（ps:这些祖先节点并不满足名称搜索，但也是合法的）
  const flatValidIds = new Set<number>();

  flatTargetList.forEach((item) => {
    flatValidIds.add(item.resourceId as number);
    while (item.parentResourceId) {
      flatValidIds.add(item.parentResourceId as number);
      item = allResourceMap.get(item.parentResourceId as number) as any;
    }
  });

  const flatValidList = Array.from(flatValidIds).map((id) => allResourceMap.get(id));
  const treeData = makeTreeData(flatValidList as Resource.ResourceItem[]);

  const { pageNum, pageSize } = paginationObj;
  const pageData = treeData.slice((pageNum - 1) * pageSize, pageNum * pageSize);
  const totalCount = treeData.length;

  return { pageData, totalCount };
};

const makeTreeData = (flatValidList: Resource.ResourceItem[]) => {
  const tree: Resource.ResourceItem[] = [];
  const treeDataMap = new Map<number, Resource.ResourceItem>();

  flatValidList.forEach((item) => {
    treeDataMap.set(item.resourceId as number, item);
  });

  flatValidList.forEach((item) => {
    if (item) {
      // 根节点
      if (item?.parentResourceId === 0) {
        tree.push(item);
      } else {
        const parent = treeDataMap.get(item!.parentResourceId as number);
        parent!.children = parent?.children ? parent?.children.concat(item) : [item];
      }
    }
  });
  return tree.reverse();
};
const onSearch = (searchData: { projectIds?: number[]; resourceName: string }) => {
  formData = { ...searchData };
  getList();
};

const onReset = (searchData: { projectIds?: number[]; resourceName: string }) => {
  paginationObj.pageNum = 1;
  paginationObj.pageSize = 10;
  formData = { ...searchData };
  getList();
};

// 添加/编辑抽屉
const drawerType = ref('create');
const editDrawerable = ref(false);
const resourceInfo = ref<Resource.ResourceItem>();

const onCreate = () => {
  resourceInfo.value = undefined;
  drawerType.value = 'create';
  editDrawerable.value = true;
};

const editRow = (row: Resource.ResourceItem) => {
  const resourceTempInfo = cloneDeep(row);
  resourceTempInfo.sysProId = [resourceTempInfo.sysId, resourceTempInfo.projectId];
  drawerType.value = 'edit';
  resourceInfo.value = resourceTempInfo;
  editDrawerable.value = true;
};

onMounted(async () => {
  const res = await getLoginProjects();
  const { code, data } = res;
  if (`${code}` === '0') {
    projectList.value = data.loginProject;
    formData.projectIds = projectList.value.map((item) => item.projectId as number);
    getList();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_e_button = _resolveComponent("e-button")!
  const _component_e_block = _resolveComponent("e-block")!
  const _component_EContent = _resolveComponent("EContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_EContent, { block: true }, {
        header: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_e_block, {
              title: "资源管理",
              sider: false
            }, {
              "header-right": _withCtx(() => [
                _createVNode(_component_e_button, { onClick: onCreate }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加资源")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(ResourceSearch, {
              "project-list": projectList.value,
              onOnSearch: onSearch,
              onOnReset: onReset
            }, null, 8, ["project-list"])
          ])
        ]),
        main: _withCtx(() => [
          _createVNode(ResourceTable, {
            "table-list": tableList.value,
            loading: loading.value,
            onOnEdit: editRow,
            onUpdateTable: getList
          }, null, 8, ["table-list", "loading"]),
          _createVNode(Pagination, {
            pageNo: paginationObj.pageNum,
            "onUpdate:pageNo": _cache[0] || (_cache[0] = ($event: any) => ((paginationObj.pageNum) = $event)),
            pageSize: paginationObj.pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((paginationObj.pageSize) = $event)),
            total: paginationObj.totalCount,
            onPagination: getList
          }, null, 8, ["pageNo", "pageSize", "total"])
        ]),
        _: 1
      })
    ]),
    (editDrawerable.value)
      ? (_openBlock(), _createBlock(EditResourceDrawer, {
          key: 0,
          drawerVisible: editDrawerable.value,
          "onUpdate:drawerVisible": _cache[2] || (_cache[2] = ($event: any) => ((editDrawerable).value = $event)),
          type: drawerType.value,
          "resource-info": resourceInfo.value,
          onOnSuccess: getList
        }, null, 8, ["drawerVisible", "type", "resource-info"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})